module.exports = __webpack_public_path__ + "img/ipad-horizontal.df07115b.svg";